import { useReactFlow } from '@xyflow/react';
import { memo, useCallback, useState } from 'react';
import { DialogTrigger } from 'react-aria-components';

import { Button, Heading, Text } from '@/components/core';
import { NewTriggerModal, TriggerOption } from '@/components/flow';
import { AddIcon } from '@/components/icons';
import { useAddTrigger } from '@/hooks';

export type EmptyTriggerNodeContentProps = {
  agentId: string;
};

const IEmptyTriggerNodeContent = ({ agentId }: EmptyTriggerNodeContentProps) => {
  const [newTriggerModelOpened, setNewTriggerModalOpened] = useState(false);

  const builder = useReactFlow();

  const onSuccess = useCallback(() => {
    builder.setNodes((nodes) => nodes);
    setNewTriggerModalOpened(false);
  }, [builder]);

  const { addTrigger, isPending: isAddingTrigger } = useAddTrigger({ onSuccess });

  const onTriggerOptionSelected = useCallback(
    async (triggerOption: TriggerOption) => {
      await addTrigger({ agentId, triggerOption });
    },
    [addTrigger, agentId]
  );

  return (
    <DialogTrigger>
      <Button
        variant="plain"
        className="flex h-[4rem] w-full items-center justify-center gap-2"
        onPress={() => setNewTriggerModalOpened(true)}
      >
        <AddIcon variant="trigger" />
        <Heading>Add trigger</Heading>
      </Button>
      <NewTriggerModal
        onTriggerOptionSelected={onTriggerOptionSelected}
        isAddingTrigger={isAddingTrigger}
        isOpen={newTriggerModelOpened}
        onOpenChange={() => setNewTriggerModalOpened(false)}
      />
    </DialogTrigger>
  );
};

export const EmptyTriggerNodeContent = memo(IEmptyTriggerNodeContent) as typeof IEmptyTriggerNodeContent;
